import React, { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { AuthCard } from "@/pages/ResetPassword";

export default function MagicLogin() {
  const [params] = useSearchParams();
  const [error, setError] = useState("");
  const sent = useRef(false);
  useEffect(() => {
    if (sent.current) return;
    sent.current = true;
    const token = params.get("token");
    if (!token) { setError("This sign-in link is missing its token."); return; }
    api.post("/auth/magic-link", { token })
      .then(({ data }) => { localStorage.setItem("mc_agency_token", data.token); window.location.replace("/console"); })
      .catch((e) => setError(formatApiError(e.response?.data?.detail)));
  }, [params]);
  return error
    ? <AuthCard title="Sign-in link unavailable" subtitle={error} />
    : <AuthCard title="Signing you in…" />;
}
